<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <router-link
          v-if="
            $store.state.user.is_admin === 1 ||
            $store.state.user.is_admin === 2 ||
            $store.state.user.is_admin === 4
          "
          class="btn btn-primary"
          style="float: right; margin-bottom: 20px"
          to="checkRequests/approve"
        >
          Aprovar Solicitações
        </router-link>
      </div>
      <div class="col-md-12">
        <div v-if="loading" class="text-center" style="padding: 50px">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-2">Carregando registros...</p>
        </div>

        <base-crud
          v-show="!loading"
          ref="baseCrud"
          crud-name="Solicitações de marcação"
          new-text="Nova Solicitação"
          :table="checkRequestsTable"
          :columns="columns"
          :options="options"
          :custom-filters="customFilters"
          :end-point="endPoint"
          :enable-add="true"
          :enable-edit="false"
          :enable-delete="false"
          :enable-view="false"
          :data-form="dataForm"
          @setDateFilter="setDateFilter"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

function format(datetime) {
  return moment(datetime).format("DD/MM/YYYY HH:mm:ss");
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      loading: true,

      checkRequestsTable: "checkRequestsTable",
      approverNames: {},
      alocations: [],
      dateFilter: "",
      customFilters: [
        {
          name: "datetime",
          call: "setDateFilter",
          type: "calendar",
        },
      ],
      columns: [
        "id",
        "datetime",
        "user_id",
        "approver_id",
        "alocation_id",
        "status_id",
        "justification",
        "approver_justification",
      ],
      tableData: [
        "id",
        "datetime",
        "user_id",
        "approver_id",
        "alocation_id",
        "status_id",
        "justification",
        "approver_justification",
      ],
      options: {
        filterByColumn: true,
        filterable: ["id", "user_id", "alocation_id", "status_id"],
        sortable: [
          "id",
          "datetime",
          "user_id",
          "approver_id",
          "alocation_id",
          "status_id",
          "approver_justification",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        listColumns: {
          status_id: [
            { id: 1, text: "Pendente" },
            { id: 2, text: "Aprovado" },
            { id: 3, text: "Recusado" },
          ],
        },
        texts: {
          filterPlaceholder: "Selecione",
          selectStatusPlaceholder: "Selecione",
        },
        headings: {
          id: "ID",
          datetime: "Data e hora",
          user_id: "Usuário",
          approver_id: "Aprovador",
          alocation_id: "Alocação",
          status_id: "Status",
          justification: "Justificativa do colaborador",
          approver_justification: "Justificativa do aprovador",
        },
        requestFunction(data) {
          const vm = this;
          const requestData = {};

          const queryString = vm.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [
            "user",
            "user.alocations",
            "approver",
            "status",
          ];

          return axios
            .get(`${vm.url}?${queryString}`, requestData)
            .then((response) => {
              vm.$parent.$parent.$parent.loading = false;
              return response;
            })
            .catch((error) => {
              vm.$parent.$parent.$parent.loading = false;
              vm.dispatch("error", error);
            });
        },
        templates: {
          datetime(createElement, rowData) {
            if (!rowData || !rowData.datetime) return "N/A";
            return format(rowData.datetime);
          },
          user_id(createElement, rowData) {
            if (!rowData || !rowData.user) return "N/A";
            return rowData.user.name;
          },
          approver_id(createElement, rowData) {
            if (!rowData) return "N/A";
            if (!rowData.approver_id) return "Pendente";
            if (rowData.approver && rowData.approver.name) {
              return rowData.approver.name;
            }
          },
          status_id(createElement, rowData) {
            const statusMap = {
              1: "Pendente",
              2: "Aprovado",
              3: "Recusado",
            };
            return statusMap[rowData.status_id] || "Desconhecido";
          },
          justification(createElement, rowData) {
            return rowData && rowData.justification
              ? rowData.justification
              : "—";
          },
          approver_justification(createElement, rowData) {
            return rowData && rowData.approver_justification
              ? rowData.approver_justification
              : "—";
          },
          alocation_id(createElement, rowData) {
            if (rowData.user && rowData.user.alocations_names) {
              return rowData.user.alocations_names;
            }
            if (
              rowData.user &&
              rowData.user.alocations &&
              rowData.user.alocations.length
            ) {
              return rowData.user.alocations
                .map((alocation) => alocation.name)
                .join(", ");
            }
            if (rowData.alocation && rowData.alocation.name) {
              return rowData.alocation.name;
            }
            return "N/A";
          },
        },
      },
      endPoint: "checkrequests/",

      dataForm: {},
    };
  },
  mounted() {
    this.getAlocations();
  },
  methods: {
    setDateFilter(value) {
      this.dateFilter = value || "";
    },
    getAlocations() {
      const api = `${this.$store.state.api}alocations`;
      return axios
        .get(api)
        .then((response) => {
          const list = (response.data.data || []).map((item) => ({
            id: item.id,
            text: item.name,
          }));
          this.alocations = list;
          this.options.listColumns.alocation_id = list;
        })
        .catch((error) => {
          console.error("Erro ao carregar alocações", error);
        });
    },
    query(queryFilters) {
      const columns = {
        id: "id",
        user_id: "name",
        approver_id: "approver_name",
        alocation_id: "alocation_id",
        status_id: "status_id",
      };
      let filters = "orderByDesc=id&";

      if (this.dateFilter) {
        filters += `date=${encodeURIComponent(this.dateFilter)}&`;
      }

      $.each(queryFilters, (index, value) => {
        if (
          columns[index] &&
          value !== null &&
          value !== undefined &&
          value !== ""
        ) {
          filters += `${columns[index]}=${encodeURIComponent(value)}&`;
        }
      });

      return filters;
    },
    getApproverName(id) {
      if (!id || this.approverNames[id]) return;

      this.$set(this.approverNames, id, "Carregando...");

      axios
        .get(`${this.$store.state.api}users/${id}`)
        .then((response) => {
          this.$set(this.approverNames, id, response.data.name);
        })
        .catch((error) => {
          this.$set(this.approverNames, id, "Erro");
          console.error("Erro ao buscar aprovador:", error);
        });
    },
  },
};
</script>
<style scoped>
.VuePagination {
  text-align: center;
}

select[name="vf__status_id"] option:first-child {
  font-size: 0;
}

select[name="vf__status_id"] option:first-child:after {
  content: "Selecione";
  font-size: 14px;
}
</style>
